import _ from 'lodash';
import produce from 'immer';

import { defaultProcessingState } from '../utils';

import {
  REPORT_FIND_START,
  REPORT_FIND_FULFILL,
  REPORT_FIND_REJECT,
  REPORT_GET_START,
  REPORT_GET_FULFILL,
  REPORT_GET_REJECT,
  REPORT_CREATE_START,
  REPORT_CREATE_FULFILL,
  REPORT_CREATE_REJECT,
  REPORT_PATCH_START,
  REPORT_PATCH_FULFILL,
  REPORT_PATCH_REJECT,
  REPORT_REMOVE_START,
  REPORT_REMOVE_FULFILL,
  REPORT_REMOVE_REJECT,
  REPORT_ITEM_PATCH_START,
  REPORT_ITEM_PATCH_FULFILL,
  REPORT_ITEM_PATCH_REJECT,
  REPORT_ITEM_REMOVE_START,
  REPORT_ITEM_REMOVE_FULFILL,
  REPORT_ITEM_REMOVE_REJECT,
  REPORT_DESIGNING_MODE_START,
  REPORT_DESIGNING_MODE_FINISH,
} from './report.actions';

const defaultState = {
  find: defaultProcessingState(),
  get: defaultProcessingState(),
  create: defaultProcessingState(),
  patch: defaultProcessingState(),
  remove: defaultProcessingState(),
  createItem: defaultProcessingState(),
  patchItem: defaultProcessingState(),
  removeItem: defaultProcessingState(),
  data: {},
  designingId: null,
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case REPORT_FIND_START: {
      ++draft.find.processing;
      return draft;
    }

    case REPORT_FIND_FULFILL: {
      --draft.find.processing;
      draft.find.error = null;
      draft.data = {
        ...draft.data,
        ..._.keyBy(action.payload.result.data, 'id'),
      };
      return draft;
    }

    case REPORT_FIND_REJECT: {
      --draft.find.processing;
      draft.find.error = action.payload;
      return draft;
    }

    case REPORT_GET_START: {
      ++draft.get.processing;
      return draft;
    }

    case REPORT_GET_FULFILL: {
      --draft.get.processing;
      draft.get.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case REPORT_GET_REJECT: {
      --draft.get.processing;
      draft.get.error = action.payload;
      return draft;
    }

    case REPORT_CREATE_START: {
      ++draft.create.processing;
      return draft;
    }

    case REPORT_CREATE_FULFILL: {
      --draft.create.processing;
      draft.create.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case REPORT_CREATE_REJECT: {
      --draft.create.processing;
      draft.create.error = action.payload;
      return draft;
    }

    case REPORT_PATCH_START: {
      ++draft.patch.processing;
      return draft;
    }

    case REPORT_PATCH_FULFILL: {
      --draft.patch.processing;
      draft.patch.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case REPORT_PATCH_REJECT: {
      --draft.patch.processing;
      draft.patch.error = action.payload;
      return draft;
    }

    case REPORT_REMOVE_START: {
      ++draft.remove.processing;
      return draft;
    }

    case REPORT_REMOVE_FULFILL: {
      --draft.remove.processing;
      draft.remove.error = null;
      draft.data = _.omit(draft.data, action.payload.result);
      return draft;
    }

    case REPORT_REMOVE_REJECT: {
      --draft.remove.processing;
      draft.remove.error = action.payload;
      return draft;
    }

    case REPORT_ITEM_PATCH_START: {
      ++draft.patchItem.processing;
      return draft;
    }

    case REPORT_ITEM_PATCH_FULFILL: {
      --draft.patchItem.processing;
      draft.patchItem.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case REPORT_ITEM_PATCH_REJECT: {
      --draft.patchItem.processing;
      draft.patchItem.error = action.payload;
      return draft;
    }

    case REPORT_ITEM_REMOVE_START: {
      ++draft.removeItem.processing;
      return draft;
    }

    case REPORT_ITEM_REMOVE_FULFILL: {
      --draft.removeItem.processing;
      draft.removeItem.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case REPORT_ITEM_REMOVE_REJECT: {
      --draft.removeItem.processing;
      draft.removeItem.error = action.payload;
      return draft;
    }

    case REPORT_DESIGNING_MODE_START: {
      draft.designingId = action.payload.id;
      return draft;
    }

    case REPORT_DESIGNING_MODE_FINISH: {
      draft.designingId = null;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
